import { Form, Formik } from 'formik';
import { BsFillSendFill } from 'react-icons/bs';
import CustomButton from '../CommonComps/Buttons/CustomButton';
import LegalInputField from '../CommonComps/Inputs/LegalInputField';
import LegalTextAreaField from '../CommonComps/Inputs/LegalTextAreaField';

const ContactUsForm = () => {
  // rendering contact us form component here
  return (
    <div className='w-full md:w-1/2'>
      <div className='block md:hidden mb-5'>
        <h3 className='text-3xl text-center md:text-left md:text-[45px] leading-[1] font-medium'>
          Got any questions?
        </h3>
        <h3 className='text-3xl text-center md:text-left md:text-[45px] leading-[1] text-legal-brown font-bold italic mt-1'>
          Contact with us now!
        </h3>
      </div>

      <Formik
        initialValues={{
          subject: '',
          email: '',
          first_name: '',
          last_name: '',
          message: '',
        }}
        onSubmit={(values) => console.log(values)}
      >
        {(props) => (
          <Form className='space-y-5  font-marcellus'>
            <LegalInputField
              type='text'
              name='subject'
              label='Subject'
              placeholder='Enter your subject here...'
              isRequired
            />

            <LegalInputField
              type='email'
              name='email'
              label='Email'
              placeholder='Enter your email here...'
              isRequired
            />

            <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
              <LegalInputField
                type='text'
                name='first_name'
                label='First Name'
                placeholder='Enter your first name here...'
                isRequired
              />

              <LegalInputField
                type='text'
                name='last_name'
                label='Last Name'
                placeholder='Enter your last name here...'
                isRequired
              />
            </div>

            <LegalTextAreaField
              name='message'
              label='Message'
              placeholder='Type your message here...'
              isRequired
            />

            <div className='lg:w-4/5 mx-auto'>
              <CustomButton
                type='submit'
                title='Submit'
                className='w-full'
                icon={
                  <BsFillSendFill className='size-5 duration-500 group-hover:rotate-45' />
                }
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ContactUsForm;
